/**
 * @file Openapi Schema
 * @version 0.1.0
 * @author Openapi Generator src_common/server/node_task/run_app/openapi/openapi.ts
 * @date 2025-07-10T10:11:09.619Z
 *
 * Details:
 * --- File generated by generator do not modify this file manually ---
 */

import { z } from 'zod';


// #/components/schemas/identitySessionIdResponse
export const IdentitySessionIdResponseZod = z.object({
    id: z.string(),
});
export type IdentitySessionIdResponseType = z.TypeOf<typeof IdentitySessionIdResponseZod>;


// #/components/schemas/identityFinalizeRequest
export const IdentityFinalizeRequestZod = z.object({
    accountId: z.number(),
    universe: z.string(),
    rawIdmidssionResult: z.string(),
});
export type IdentityFinalizeRequestType = z.TypeOf<typeof IdentityFinalizeRequestZod>;


// #/components/schemas/identityEmptyResponse
export const IdentityEmptyResponseZod = z.unknown();
export type IdentityEmptyResponseType = z.TypeOf<typeof IdentityEmptyResponseZod>;


// #/components/schemas/identityVerificationProgress
export const IdentityVerificationProgressZod = z.union([z.literal('not-started'), z.literal('initiated'), z.literal('failed'), z.literal('finished')]);
export type IdentityVerificationProgressType = z.TypeOf<typeof IdentityVerificationProgressZod>;


// #/components/schemas/identityVerificationVariant
export const IdentityVerificationVariantZod = z.union([z.literal('IdCard'), z.literal('IdCardProofOfAddress'), z.literal('IdCardAndFace'), z.literal('IdCardAndFaceProofOfAddress')]);
export type IdentityVerificationVariantType = z.TypeOf<typeof IdentityVerificationVariantZod>;


// #/components/schemas/identityVerificationProgressResponse
export const IdentityVerificationProgressResponseZod = z.object({
    id: z.number(),
    universe: z.string(),
    accountId: z.number(),
    progress: IdentityVerificationProgressZod,
    rawResult: z.unknown(),
    createdAt: z.string(),
    finalizedAt: z.string().optional(),
    verificationVariant: IdentityVerificationVariantZod,
});
export type IdentityVerificationProgressResponseType = z.TypeOf<typeof IdentityVerificationProgressResponseZod>;

